
import uiContext from './uiContext';
import React, { useEffect, Fragment, useState, useContext } from 'react';
import Loader from './Loader';
import { ResourcesContext } from '../ContextProvider';
import {useHistory} from 'react-router-dom'
import {API} from '../../services/api';
/**
 * Provider inicial de carga de datos
 *
 */
function UIComponentAndProvider(props) {
  const [isShowingLoader, setIsShowingLoader] = useState();
  const [login, setLogin] = useState(false);
  const [name, setName] = useState("");
  const [user, setUser] = useState({});
  const [showMenu, setShowMenu] = useState(false);

  const resources = useContext(ResourcesContext);
  const [caletasCount, setCaletasCount] = useState("---");
  const [hombresCount, setHombresCount] = useState("---");
  const [mujeresCount, setMujeresCount] = useState("---");
  const history = useHistory();
  const API = process.env.REACT_APP_BASE_API || 'http://localhost:3000';

  useEffect(() => {

    //setIsShowingLoader(true);
    resources.getRegions().then(result => {
      let woman = 0;
      let man = 0;
      if (result != null && result.data != null) {
        result.data.map((c) => {
          if (c.nroMujeres) { woman += c.nroMujeres }
          if (c.nroHombres) { man += c.nroHombres }
        })
        setCaletasCount(result.data.length);
        setHombresCount(man);
        setMujeresCount(woman);
        setIsShowingLoader(false);
      }
    }).catch(err => {
      console.warn(err);
    })


  }, [])

  return (
    <uiContext.Provider value={{
      showLoader: (e) => { if (e == null || e === false) { window.scrollTo(0, 0); } document.body.style.overflow = 'hidden'; setIsShowingLoader(true) },
      hideLoader: () => { document.body.style.overflow = 'auto'; setIsShowingLoader(false) },
      login: login,
      setLogin: (x) => { setLogin(x) },
      name: name,
      setName: (v) => { setName(v) },
      mujeresCount: mujeresCount,
      hombresCount: hombresCount,
      caletasCount: caletasCount,
      showMenu:showMenu,
      setShowMenu: (x)=> setShowMenu(x),
      user,
      setUser,
      API
    }}>

      {/* Content */}
      <Fragment>{props.children}</Fragment>
      {/* Loader */}
      {isShowingLoader && (<Loader />)}
    </uiContext.Provider>
  )
}

export { uiContext, UIComponentAndProvider };